export const comments_3296372 = {"data":{"data":[],"links":{}}}